// src/components/LanguageOptions.js
import React, { useState, useEffect } from "react";
import '../stylesheets/styles.css'
import { APP_VERSION, APP_VERSION_DATE, HYMNFORGE_URL, isNewerVersion } from '../utilities/version';

// const HYMNFORGE_URL = 'https://songstack.getpartaker.com/hymnforge';

const LanguageOptions = props => {
    const { availableLangs, selectedLangs, updateSelectedLangs, hymnforgeInfo, close } = props
    const [ langs, setLangs ] = useState(selectedLangs)

    // Initialize with English selected if no languages are selected
    useEffect(() => {
        if (langs.length === 0) {
            const englishLang = availableLangs.find(lang => lang.code === 'en');
            if (englishLang) {
                setLangs([englishLang]);
            }
        }
	// eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSelected = (lang) => {
        let newLangs;
        const isSelected = langs.some(l => l.code === lang.code);
        
        if (isSelected) {
            // Don't allow deselecting English if it's the only language
            if (lang.code === 'en' && langs.length === 1) {
                return;
            }
            newLangs = langs.filter(l => l.code !== lang.code);
        } else {
            newLangs = [...langs, lang];
        }
        
        setLangs(newLangs);
    }

    const onApply = () => {
        updateSelectedLangs(langs);
        close();
    }

    const onClear = () => {
        // When clearing, keep English selected
        const englishLang = availableLangs.find(lang => lang.code === 'en');
        if (englishLang) {
            setLangs([englishLang]);
            updateSelectedLangs([englishLang]);
        } else {
            setLangs([]);
            updateSelectedLangs([]);
        }
        close();
    }

    const getCachedSongsCount = () => {
        let totalSongs = 0;
        const cacheKeys = Object.keys(localStorage).filter(key => key.startsWith('cachedSongs_'));
        console.log('Found cache keys:', cacheKeys);

        cacheKeys.forEach(key => {
            try {
                const cachedData = JSON.parse(localStorage.getItem(key));
                console.log(`Cache key: ${key}`, cachedData);

                if (cachedData && cachedData.data && cachedData.data.songs) {
                    console.log(`Songs data for ${key}:`, cachedData.data.songs);
                    console.log(`Is array:`, Array.isArray(cachedData.data.songs));

                    // Handle different possible structures
                    let songsData = cachedData.data.songs;

                    // If songs is an object with a 'songs' property (like the JSON structure)
                    if (songsData && typeof songsData === 'object' && songsData.songs) {
                        songsData = songsData.songs;
                        console.log(`Found nested songs property:`, songsData);
                    }

                    if (Array.isArray(songsData)) {
                        const count = songsData.length;
                        console.log(`Array length for ${key}: ${count}`);
                        totalSongs += count;
                    } else if (typeof songsData === 'object' && songsData !== null) {
                        const count = Object.keys(songsData).length;
                        console.log(`Object keys length for ${key}: ${count}`);
                        totalSongs += count;
                    }
                }
            } catch (e) {
                console.log('Error parsing cached data:', e);
            }
        });

        console.log('Total cached songs:', totalSongs);
        return totalSongs;
    }

    const onReloadCache = () => {
        // Clear all cached songs data
        Object.keys(localStorage).forEach(key => {
            if (key.startsWith('cachedSongs_')) {
                localStorage.removeItem(key);
            }
        });

        // Reload the page to fetch fresh data
        window.location.reload();
    }

    const isSelected = lang => {
        return langs.some(l => l.code === lang.code);
    }

    // Determine whether a newer version is available
    const updateAvailable = hymnforgeInfo &&
        hymnforgeInfo.version &&
        isNewerVersion(hymnforgeInfo.version, APP_VERSION);

    const Languages = availableLangs.map((al, i) => (
        <div className="checkbox-input" key={al.code}>
            <input
                type="checkbox"
                id={al.code}
                name={al.code}
                value={al.name}
                checked={isSelected(al)}
                onChange={() => onSelected(al)}
            />
            {al.name}
        </div>
    ));

    return (
        <div className="lang-bg">
            <h3>Select Language</h3>
            {Languages}
            <div className="apply-button-container">
                <button className="clear-button" type="button" onClick={onClear}>Clear Selection</button>
                <button className="apply-button" type="button" onClick={onApply}>Apply</button>
            </div>

            <div className="cache-section">
                <div className="cache-info">
                    <p>If songs are not loading properly, you can reset the cache and download them again.</p>
                    <button className="reset-cache-button" type="button" onClick={onReloadCache}>Reset cache</button>
                </div>
                <div className="cached-songs-count">
                    Cached songs: {getCachedSongsCount()}
                </div>
            </div>

            <div className="settings-footer">
                <p className="settings-footer-branding">
                    Powered by HymnForge. To host your own online songbook, visit{' '}
                    <a href={HYMNFORGE_URL} target="_blank" rel="noopener noreferrer">
                        songstack.getpartaker.com/hymnforge
                    </a>
                </p>
                <p className="settings-footer-version">
                    HymnForge version {APP_VERSION} <span style={{ fontSize: '80%' }}>({APP_VERSION_DATE})</span>.
                    {updateAvailable && (
                        <>
                            {' '}An update is available.{' '}
                            <a href={HYMNFORGE_URL} target="_blank" rel="noopener noreferrer">
                                Learn more
                            </a>
                        </>
                    )}
                </p>
            </div>
        </div>
    );
}

export default LanguageOptions;
